var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditCircleSelected = function SvgEditCircleSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 16.336c-4.39 0-7.969-3.57-7.969-7.969C.031 3.977 3.61.398 8 .398c4.398 0 7.969 3.579 7.969 7.97A7.97 7.97 0 0 1 8 16.335m3.188-10.219.585-.586c.266-.265.282-.57.032-.812l-.18-.188c-.242-.242-.54-.21-.805.04l-.593.593zM5.422 11.86l5.281-5.257-.96-.961-5.266 5.265-.454 1.063a.229.229 0 0 0 .282.312z"
  })));
};
export default SvgEditCircleSelected;